import { css } from 'lit';

export const styles = css `
  u-chip {
    flex-basis: 0;
  }

  .input {
    display: flex;
    gap: var(--u-chip-field-chips-gap, var(--u-spacing-extra-small, 4px));
    flex-wrap: wrap;
  }
  .input:has(u-chip) {
    margin-top: var(--u-chip-field-chips-margin, var(--u-spacing-extra-small, 4px));
  }
  .input input {
    width: auto;
    flex-basis: 200px;
    padding: 4px 0;
    margin-block: -4px;
  }
`;
